import { NodeData } from '@Types';

export interface NodeHandlers {
	onEditClick: (nodeId: string) => void;
	onDeleteClick: (nodeId: string) => void;
	onDuplicateClick: (nodeId: string) => void;
}

export const buildNodeData = (
	id: string | number,
	label: string | undefined,
	nodeData: NodeData | undefined,
	handlers: NodeHandlers,
	isRehabTreeEditable: boolean,
) => ({
	id,
	label,
	nodeData,
	title: label,
	onEditClick: handlers.onEditClick,
	onDeleteClick: handlers.onDeleteClick,
	onDuplicateClick: handlers.onDuplicateClick,
	isRehabTreeEditable,
});
